module.exports = __webpack_public_path__ + "eta24-73c75580.webp";